import React from 'react'
import _ from "underscore";

const Variables = function (props) {
    if (!props.context.environmentVariables) return null;
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} key={id}/>);
    
    if (props.context && !_.isEmpty(props.context.environmentVariables) && childBlocks.length > 0) {
        return (
            <category name='Global Variables' id='EnvVariables' iconclass='category with-icon-paths snap-icon-global_variable_dual'>
                <label text="Global Variables"/>
                { childBlocks }
            </category>
        );
    }
    
    return null;
}

export default Variables;
